const requestStateKeyName = 'requestState';
const requestStatesKeyName = 'requestStates';

const hasInProgressKeyName = 'hasInProgress';
const lastStatusCodeKeyName = 'lastStatusCode';
const countQueriesKeyName = 'countQueries';
const hasSuccessQueryKeyName = 'hasSuccessQuery';
/**
 * Создание объекта состояния запроса
 */
export function createRequestState(objKey = null) {
  return {
    [objKey || requestStateKeyName]: {
      [hasInProgressKeyName]: false,
      [lastStatusCodeKeyName]: null,
      [countQueriesKeyName]: 0,
      [hasSuccessQueryKeyName]: null
    }
  };
}

/**
 * Создание объекта коллекции состояний запроса (пустой объект с фиксированным ключем)
 */
export function createRequestStates(objItemsKeys = []) {
  let items = {};
  if (objItemsKeys.length > 0) {
    objItemsKeys.map(itemKey => {
      items = { ...items, ...createRequestState(itemKey) };
      return null;
    });
  }
  return { [requestStatesKeyName]: items };
}

/**
 * Переводим store запроса в состояние процесса
 */
export function setRequestStateInProgress(
  state,
  keyName,
  hasInProgress = true
) {
  if (keyName) {
    return state.merge({
      [requestStatesKeyName]: {
        ...state[requestStatesKeyName],
        ...{
          [keyName]: {
            [hasInProgressKeyName]: hasInProgress,
            [lastStatusCodeKeyName]: null,
            [countQueriesKeyName]: state[requestStatesKeyName][keyName]
              ? state[requestStatesKeyName][keyName][countQueriesKeyName]
              : 0,
            [hasSuccessQueryKeyName]: null
          }
        }
      }
    });
  }
  return state.merge({
    [requestStateKeyName]: {
      [hasInProgressKeyName]: hasInProgress,
      [lastStatusCodeKeyName]: null,
      [countQueriesKeyName]: state[requestStatesKeyName]
        ? state[requestStateKeyName][countQueriesKeyName]
        : 0,
      [hasSuccessQueryKeyName]: null
    }
  });
}

/**
 * Переводим store запроса в состояние финализации
 */
export function setRequestStateFinish(
  state,
  statusCode,
  hasSuccessQuery,
  keyName
) {
  if (keyName) {
    return state.merge({
      [requestStatesKeyName]: {
        ...state[requestStatesKeyName],
        ...{
          [keyName]: {
            [hasInProgressKeyName]: false,
            [lastStatusCodeKeyName]: statusCode,
            [countQueriesKeyName]: state[requestStatesKeyName][keyName]
              ? state[requestStatesKeyName][keyName][countQueriesKeyName] + 1
              : 0,
            [hasSuccessQueryKeyName]:
              typeof hasSuccessQuery === 'boolean' ? hasSuccessQuery : null
          }
        }
      }
    });
  }
  return state.merge({
    [requestStateKeyName]: {
      [hasInProgressKeyName]: false,
      [lastStatusCodeKeyName]: statusCode,
      [countQueriesKeyName]: state[requestStatesKeyName]
        ? state[requestStateKeyName][countQueriesKeyName] + 1
        : 0,
      [hasSuccessQueryKeyName]:
        typeof hasSuccessQuery === 'boolean' ? hasSuccessQuery : null
    }
  });
}



// WEBPACK FOOTER //
// ./src/mt-react-common/utils/reducerHalpers/requestState.js